import FeatureGrid from "@/components/base/FeatureGrid";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { patientPrep } from "@/mocks/patientInfo";

export default function PatientPrep() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Randevu öncesi"
            title="Çekime nasıl hazırlanmalısınız?"
            description="Dental görüntüleme için özel bir hazırlık gerekmez. Yine de aşağıdaki birkaç küçük adım, işleminizi daha da hızlı ve rahat hâle getirir."
          />
        </Reveal>

        <div className="mt-14">
          <FeatureGrid items={patientPrep} columns={2} />
        </div>
      </div>
    </section>
  );
}